import { ChartBase } from 'components/common';
import { LabelItem } from 'components/segments';
import { Skeleton } from 'components/ui';
import { useMemo } from 'react';
import { useAppSelector } from 'store';
import { composableFiltersState } from 'store/composableFiltersSlice';
import { useGetCustomerStatisticsQuery } from 'store/services/segmentsApi';
import { userDetailsState } from 'store/userDetailsSlice';
export default function ChartOrderSources() {
  const { currentStore } = useAppSelector(userDetailsState);

  const {
    output: { filtersApiPayload },
  } = useAppSelector(composableFiltersState);

  const { data, isFetching: loading } = useGetCustomerStatisticsQuery(
    {
      body: filtersApiPayload,
      params: {
        store_name: String(currentStore.completeInfo?.store_name),
        metric_list: ['order_source'],
      },
    },
    { skip: !!!currentStore.completeInfo?.store_name }
  );

  const totalSum = useMemo(() => {
    if (!data?.order_source?.length) return 1;
    return data.order_source.reduce((acc, curr) => acc + curr.value, 0);
  }, [data]);

  let web: number = 0;
  let pos: number = 0;
  let other: number = 0;

  data?.order_source?.forEach((item) => {
    switch (item.source) {
      case 'web':
        if (item.value) web = item.value;
        break;
      case 'pos':
        if (item.value) pos = item.value;
        break;
      case 'other':
        if (item.value) other = item.value;
        break;
      default:
        break;
    }
  });

  const chartData = useMemo(
    () => ({
      labels: ['Percentage'],
      datasets: [
        {
          label: 'Web',
          backgroundColor: '#125970',
          borderColor: '#125970',
          barThickness: 44,
          data: [web / totalSum],
        },
        {
          label: 'Pos',
          backgroundColor: '#E2BE3B',
          borderColor: '#E2BE3B',
          barThickness: 44,
          data: [pos / totalSum],
        },
        {
          label: 'Other',
          backgroundColor: '#E1E1E1',
          borderColor: '#E1E1E1',
          barThickness: 44,
          data: [other / totalSum],
        },
      ],
    }),
    [web, pos, totalSum, other]
  );

  const options = {
    indexAxis: 'y',
    interaction: {
      mode: 'nearest',
    },
    maintainAspectRatio: false,

    scales: {
      y: {
        stacked: true,
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },
      x: {
        stacked: true,
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };
  if (!!!loading && !!!data?.order_source) return null;
  return (
    <div className="mt-12">
      <div className="flex justify-between -mb-8 ">
        <p className="font-bold">Order sources</p>
        {/* <p>Right Side</p> */}
      </div>

      <div className="-ml-2.5 relative">
        <ChartBase
          type="bar"
          // Passing empty array if loading to allow Skeleton to be shown
          data={loading ? [] : chartData}
          options={options}
        />
        {/* Positioning the Skeleton at same place absolutely, once the original chart size is bigger, note the negative margins */}
        <div className="absolute left-2.5 z-10 top-12 right-0.5">
          <Skeleton isLoaded={!loading}>
            <div className="h-11"></div>
          </Skeleton>
        </div>
      </div>
      <div className="flex -mt-10 space-x-24">
        <LabelItem
          color="graph_1"
          label="Web"
          highlightValue={(web / totalSum || '--').toLocaleString('en-US', {
            style: 'percent',
          })}
          loading={loading}
        />
        <LabelItem
          color="graph_2"
          label="Pos"
          highlightValue={(pos / totalSum || '--').toLocaleString('en-US', {
            style: 'percent',
          })}
          loading={loading}
        />
        <LabelItem
          color="gray"
          label="Other"
          highlightValue={(other / totalSum || '--').toLocaleString('en-US', {
            style: 'percent',
          })}
          loading={loading}
        />
      </div>
    </div>
  );
}
